export default __webpack_public_path__ + "static/media/CapaPDF.a5c70b51.svg";